import React, { useMemo } from 'react'
import RenderFormSection from "src/components/era-package/forms/RenderFormSection"
import { entryDetailFields, monthlyDetailFields, STATEMENT_TYPE, summaryDetailFields } from "../../shared"

export const StatementSummary = ({ type, ...props }) => {
  const fields = useMemo(() => {
    switch (type) {
      case STATEMENT_TYPE.entry:
        return entryDetailFields
      case STATEMENT_TYPE.monthly:
        return monthlyDetailFields
      default:
        return summaryDetailFields
    }
  }, [type])
  const details = useMemo(() => {
    return fields.reduce((acc, cur) => {
      acc[cur.name] = props[cur.name] || ''
      return acc
    }, {})
  }, [fields, props])

  return <RenderFormSection section={{
    fields,
    title: `${type === STATEMENT_TYPE.entry ? 'Entry' : 'Statement'} Summary`
  }}
    formData={details} readOnly
  />
}